/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from '../../styles/styled';
import { hexToRgb } from '../../styles/utils';
import { BAR_LOADER_INDETERMINATE_TIME, BAR_LOADER_HEIGHT, } from '../constants';
import { getBarLoaderWidth } from './helpers';
import getOverrides from '../../overrides/helper';
const Root = styled.div `
  position: relative;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borders.radius40};
  ${(props) => {
    const { fullScreen, width: barWidth } = props;
    const width = getBarLoaderWidth({ fullScreen, width: barWidth });
    return {
        width,
    };
}}
`;
const Text = styled.div `
  text-align: center;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};

  ${({ $style }) => $style};
`;
const Container = styled.div `
  height: ${BAR_LOADER_HEIGHT}px;
  width: 100%;
  border-radius: ${({ theme }) => theme.borders.radius40};
  z-index: 0;
  position: absolute;
  background-color: ${({ theme }) => hexToRgb(theme.colors.primary, 0.08)};

  ${({ $style }) => $style};
`;
const BarDeterminate = styled.div `
  height: ${BAR_LOADER_HEIGHT}px;
  width: ${(props) => `${props.value}%`};
  border-radius: ${({ theme }) => theme.borders.radius40};
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.primary};
  transition: width 0.5s linear;

  ${({ $style }) => $style};
`;
const BarIndeterminate = styled.div `
  height: ${BAR_LOADER_HEIGHT}px;
  border-radius: ${({ theme }) => theme.borders.radius40};
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.primary};
  position: relative;
  animation-name: indeterminate;
  animation-timing-function: ease-in-out;
  animation-duration: ${({ indeterminateTime }) => (`${indeterminateTime || BAR_LOADER_INDETERMINATE_TIME}s`)};
  animation-iteration-count: infinite;

  @keyframes indeterminate {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }

  ${({ $style }) => $style};
`;
const BarLoader = (props) => {
    const { value, text, isDeterminate, indeterminateTime, overrides, } = props;
    const TextOverride = getOverrides('Text', overrides);
    const ContainerOverride = getOverrides('Container', overrides);
    const DeterminateOverride = getOverrides('BarDeterminate', overrides);
    const IndeterminateOverride = getOverrides('BarIndeterminate', overrides);
    const DeterminateBar = (React.createElement(BarDeterminate, Object.assign({ value: value }, DeterminateOverride)));
    const IndeterminateBar = (React.createElement(BarIndeterminate, Object.assign({ indeterminateTime: indeterminateTime }, IndeterminateOverride)));
    return (React.createElement(Root, Object.assign({}, props),
        text && React.createElement(Text, Object.assign({}, TextOverride), text),
        React.createElement(Container, Object.assign({}, ContainerOverride)),
        isDeterminate ? DeterminateBar : IndeterminateBar));
};
export default BarLoader;
